module.exports = {
    common: {
        requestProcessFail: 'Request processing failed',
        requestFail: 'Request failed',
        networkError: 'Network request failed, please try again later',
        notFound: 'Request address not found',
        serverError: 'Internal server error',
        selectCountry: 'Please select a country',
        confirmed: 'Confirmed',
        cancelled: 'Cancelled...',
        back: 'Back',
    },

    homePage: {
        alreadyUse: 'Used',
        remain: 'Remain',
        search: 'Search',
        findIccid: 'How To Find ICCID',
        fillIccid: 'Fill in SIM Card ICCID Number',
        changeLanguage: 'LanguageChange',
        confirm: 'Confirm',
        selectLanguage: 'Please select a language',
        selectImageFile: 'Please select an image file',
        processing: 'Processing...',
        recognizeSuccess: 'Recognized successfully',
        recognizeFail: 'Recognition failed, please try again',
        recognizeEmpty: 'No ICCID recognized',
        compressFail: 'Compression failed',
        takePhoto: 'Take Photo',
        fromAlbum: 'Choose from Album',
        recognizing: 'Recognizing...',
        openingCamera: 'Opening camera...',
        cameraFail: 'Failed to open camera',
        scanFail: 'Recognition failed. Please aim at the QR code',
    },
    planPage: {
        expireNotify: 'You will no longer be able to access the live preview after your plan expires.',
        dataUsed: 'Used',
        dataRemain: 'Remain',
        planStatus: 'Status',
        planAutoRenew: 'Renew',
        planOrders: 'Orders',
        planCountry: 'Country',
        planPackage: 'Package',
        realPakcage: '9.9 Rm / 30 Days',
        autoRenewNotify: 'Every 30 Days 9.90Rm Renew Plan, Cancel Anytime。',
        goForPurchase: 'Go For Purchase',
        every: 'Every',
        days: 'Days',
        lifetimeFreeFlow: 'Lifetime Free Data',
        renew: 'Renew Plan, Cancel Anytime',
        detail: 'Detail',
        nodata: 'No Data Plan',
        autoRenewSaying: 'Auto Renew Notify',
        autoRenewSay1: 'You can cancel automatic renewal at any time and no further charges will be made after cancellation',
        autoRenewSay2: 'Enjoy super low prices.',
        renewNoticeTitle: 'Important Notice',
        renewNotice1: 'Your plan will be activated immediately after successful payment.',
        renewNotice2: 'This is an auto-renewing subscription. Please review the details before purchasing.',
        agreePrefix: 'By continuing, you agree to the ',
        subscribePolicy: 'Subscription Policy',
        agreeMiddle: ' and ',
        refundPolicy: 'Refund Policy',
        agreeSuffix: '.',
        close: 'Close',
        subscription: 'Cancel Subscription',
        cancelSubscription: 'Confirm Cancel Subscription？',
        conform: 'Confirm',
        cancel: 'Cancel',
        contact: 'Contact',
        Unlimited:'Walang Hangganan',
        cardLeftTip: '360+180 Free',
        cardLeftTip270: '180+90 Free',
        purchaseTitle: 'Purchase Package'
    },
    couponRedeem: {
        title: 'Exclusive Renewal Coupon',
        titleNewbie: 'Exclusive New User Coupon',
        subtitle: 'Salamat sa pananatili sa amin!',
        bullet1: 'Isang coupon lang bawat ICCID',
        bullet2: 'Valid hanggang {date}',
        bullet3: 'Isang beses lang!',
        claimNow: 'Kunin Na',
        goToUse: 'Gamitin',
        receiveSuccess: 'Matagumpay na na-claim',
        receiveMissing: 'Di-wasto ang coupon o ICCID.',
        useToast: 'Gamitin ang coupon na ito kapag nagbabayad ng plano.',
        claimToast: 'Makipag-ugnayan sa suporta para makumpleto ang redemption.',
        empty: 'Walang coupon sa ngayon',
        noCouponMsg: 'Walang coupon',
        buyDirect: 'Bumili Agad',
        loading: 'Naglo-load...',
    },
    payPage: {
        paymentConfirm: 'Payment Confirm',
        payContact: 'Contact',
        payPackage: 'Package',
        payDuration: 'Duration',
        payTotal: 'Total',
        paySelectPayment: 'Select Payment Method',
        payCard: 'Card',
        cardDesc: 'Only Support Subscription',
        payCardBankCredit: 'Bank Card / Credit',
        cardSupportHint: 'Supports Visa, Mastercard, Apple Pay, Google Pay',
        currentSelected: 'Currently selected',
        autoBadge: 'Automatic',
        subscribeCardDeduct: 'Credit/debit card subscription',
        subscribeEwalletDeduct: 'E-wallet subscription deduction',
        payOnceTitle: 'One-time Payment',
        payOnceDesc: 'Single payment, no auto-renewal; one payment method per row.',
        rechargeEwalletDesc: 'E-wallet one-time payment',
        rechargeQrisDesc: 'Scan code payment',
        rechargeBankDesc: 'Bank transfer one-time payment',
        rechargeRetailDesc: 'Convenience store payment',
        payEWallet: 'E-Wallet',
        payComfirm: 'Confirm Pay',
        paymentSecureHint: 'Your payment information is secure and encrypted.',
        inputContact: 'Please Input Contact',
        contactAppNumber: '{app} Number',
        contactUpdateViaApp: 'Order updates will be sent via {app}',
        contactPhonePlaceholder: 'Please enter number',
        contactPhoneMinLength: 'Please enter at least 8 digits',
        orderCouponLoading: 'Naglo-load ang coupon...',
        couponAppliedSub: 'Nailapat sa order na ito',
        couponAvailableSub: 'Available para sa order na ito',
        couponDeductLabel: 'Diskwento sa coupon',
        amountAfterDeduction: 'Halaga pagkatapos ng diskwento',
        subscribeDetailTitle: 'Subscription Details (Auto Renewal)',
        subscribeDetailSubtitle: 'View billing cycle, renewal rules, cancellation & more',
        subscribeDetailIntro: 'This is an auto-renewing subscription. By proceeding, you agree to the terms below.',
        subscribeBillingCycle: 'Billing Cycle',
        subscribeBillingCycleVal: 'Every {days} days',
        subscribeAmount: 'Amount',
        subscribeAmountVal: '{amount} per {days} days',
        subscribeNextRenewal: 'Next Renewal',
        subscribeNextRenewalVal: 'On expiry date, amount will be automatically charged.',
        subscribePaymentMethod: 'Payment Method',
        subscribePaymentMethodVal: 'Future renewals will be charged to this payment method.',
        subscribeCancelAnytime: 'Cancel Anytime',
        subscribeCancelAnytimeVal: 'You can cancel auto-renewal anytime before the next billing date. After cancellation, your plan will remain active until it expires.',
        subscribeActivation: 'Activation',
        subscribeActivationVal: 'Your plan will be activated immediately after successful payment.',
        refundSummaryTitle: 'Refund Policy (Summary)',
        refundSummarySubtitle: 'View refund eligibility, process & exceptions',
        refundSummaryIntro: 'Refunds are available only in the following cases:',
        refundSummaryCase1: 'Duplicate payment',
        refundSummaryCase2: 'Payment successful but package not activated',
        refundSummaryCase3: 'Technical issues caused by Franwell',
        refundSummaryDisclaimer: 'No refunds will be provided once the package has been successfully activated or partially used.',
        refundSummaryLink: 'View Full Refund Policy',
        agreeAutoRenew: 'I understand this is an auto-renewing subscription and agree to the terms above.',
        agreePoliciesPrefix: 'I have read and agree to the ',
        agreeAutoRenewRequired: 'Please confirm the auto-renewal subscription terms.',
        agreePoliciesRequired: 'Please agree to the Subscription Policy and Refund Policy.',
        agreeConsentRequired: 'Please check the agreement boxes above.',
        subscribePolicyPopupTitle: 'Subscription Policy',
        subscribePolicySection1Title: '1. Subscription',
        subscribePolicyS1Item1: 'Your subscription will start immediately after successful payment.',
        subscribePolicyS1Item2: 'Each subscription is valid for {days} days.',
        subscribePolicyS1Item3: 'Your subscription will automatically renew every {days} days.',
        subscribePolicyS1Item4: 'The renewal amount is {amount} per {days} days.',
        subscribePolicyS1Item5: 'Renewal payments will be automatically charged to your selected payment method.',
        subscribePolicyS1Item6: 'You can cancel auto-renewal anytime before the next billing date.',
        subscribePolicyS1Item7: 'After cancellation, your current subscription will remain active until it expires.',
        subscribePolicySection2Title: 'Subscription Cancellation Guide',
        subscribePolicyS2Step1Label: 'Step 1',
        subscribePolicyS2Step1: 'Go to the 4G page',
        subscribePolicyS2Step2Label: 'Step 2',
        subscribePolicyS2Step2: 'Find the subscription button',
        subscribePolicyS2Step3Label: 'Step 3',
        subscribePolicyS2Step3: 'Tap "Turn Off Auto-Renewal"',
        subscribePolicyS2Step4Label: 'Step 4',
        subscribePolicyS2Step4: 'Confirm cancellation',
        subscribePolicyS2Tip: 'You can continue using this service until the end of your current billing period.',
        subscribePolicyFullLink: 'View Full Subscription Policy',
        xenditSubscribeNoticeTitle: 'Important Notice',
        xenditSubscribeNotice1: 'You are subscribing between the 29th and 31st.',
        xenditSubscribeNotice2Prefix: 'Your subscription will be successful, but the actual billing will be postponed to the ',
        xenditSubscribeNotice2Highlight: '1st day of next month.',
        xenditSubscribeNotice3: 'We will provide you with free usage days for this period. Once the payment is deducted, your plan days will be automatically extended.',
        xenditSubscribeNoticeConfirm: 'Got it',
        refundPolicyPopupTitle: 'Refund Policy',
        refundPolicySection1Title: '1. Eligible for Refund',
        refundPolicyS1Intro: 'Refunds will be provided in the following cases:',
        refundPolicyS1Item1: 'Duplicate payment',
        refundPolicyS1Item2: 'Payment successful but package not activated',
        refundPolicyS1Item3: 'Technical issues caused by Franwell',
        refundPolicySection2Title: '2. Not Eligible for Refund',
        refundPolicyS2Intro: 'Refunds will not be provided in the following cases:',
        refundPolicyS2Item1: 'SIM has been activated and data service used',
        refundPolicyS2Item2: 'Partial or full usage of the package',
        refundPolicyS2Item3: 'Change of mind after purchase',
        refundPolicyS2Item4: 'Network coverage or signal issues after successful activation',
        refundPolicySection3Title: '3. Refund Process',
        refundPolicyS3Item1: 'Refunds will be processed within 3-5 business days.',
        refundPolicyS3Item2: 'The refund will be returned to the original payment method.',
        selectPaymentRequired: 'Please select a payment method',
        paymentLinkInvalid: 'Payment link is invalid',
        redirectPaymentFailed: 'Failed to open the payment page. Please try again manually.',
        createOrderFailed: 'Failed to create order',
        creatingOrder: 'Creating order for payment...',
        paymentComponentLoadFailedRefresh: 'Payment component failed to load. Please refresh the page.',
        paymentComponentLoadFailed: 'Payment component failed to load',
        paymentFailed: 'Payment failed',
        paymentCancelled: 'Payment cancelled',
        paymentInitFailed: 'Payment initialization failed',
        indonesiaPhoneInvalid: 'Format invalid. Please enter a valid Indonesian phone number',
    },
    paySuccessPage: {
        pendingResult: 'Order Pending Result',
        activationSuccess: 'Your SimCard Activation Have Submit Successfully',
        activationQuery: 'Activation State Query',
        pendingPaymentTitle: 'Order Pending Payment',
        orderNoLabel: 'OrderNo',
        redirectingPayment: 'Redirecting to payment...',
        pay: 'Payment',
        orderNoMissing: 'Order number is missing',
        paymentLinkInvalid: 'Payment link is invalid',
    },
    orderPage: {
        orderRecords: 'Order Records',
        activated: 'Activated',
        notActivated: 'Not Activated',
        closed: 'Closed',
        activateFailed: 'Activation Failed',
        paySuccess: 'Success',
        payFailed: 'Failed',
        notPaid: 'Not Paid',
        refunded: 'Refunded',
        Pending: 'Pending',
        orderRecord: 'Order Records',
        orderStatus: 'OrderStatus',
        orderPayStatus: 'PayStatus',
        orderCountry: 'Country',
        orderPackage: 'Package',
        orderIccid: 'ICCID',
        orderOrderTime: 'OrderTime',
        back: 'back'
    },
    deviceInfo: {
        title: 'Device Info',
        userId: 'USER ID',
        deviceId: 'DEVICE ID',
        operatorAlertTitle: 'Unlock Notification',
        operatorAlert: '' +
            'This device has received an official subsidy for a more favorable price and comes bundled with an official 4G SIM card for the best user experience. If you wish to remove the restrictions, you can choose to unlock it for a fee. After unlocking, you can use other compatible SIM cards.',
        unlockPermanent: 'Permanently unlock',
        unlockDescription: 'One-time payment, permanent device unlock',
        unlockDescription01: 'After unlocking, you can use any carrier\'s SIM card.',
        unlockImmediate: 'Unlock Now',
        noticeTitle: 'Unlock Instructions',
        unlockNotice: '' +
            'Friendly reminder: If you have already paid, it will take 5-10 minutes for the unlock to take effect. Please keep your network connection and try again later.'
    },
    deviceUnlockPaymentInfo: {
        title: 'Device Info',
        userId: 'USER ID',
        deviceId: 'DEVICE ID',
        total: 'Total',
        paySelectPayment: 'Select Payment Method',
        payCard: 'Card',
        payEWallet: 'E-Wallet',
        payConfirm: 'Confirm Pay',
        operatorAlert: '' +
            'This device has received an official subsidy for a more favorable price and comes bundled with an official 4G SIM card for the best user experience. If you wish to remove the restrictions, you can choose to unlock it for a fee. After unlocking, you can use other compatible SIM cards.',
        unlockPermanent: 'Permanently unlock',
        unlockDescription: 'One-time payment, permanent device unlock',
        unlockDescription01: 'After unlocking, you can use any carrier\'s SIM card.',
        unlockImmediate: 'Unlock Now',
        noticeTitle: 'Unlock Instructions',
        unlockNotice: '' +
            'Friendly reminder: If you have already paid, it will take 5-10 minutes for the unlock to take effect. Please keep your network connection and try again later.',
        unlockConfirm: "Confirm",
        unlockRequestFail: "Request failed",
        unlockTipsTitle: 'Tips',
        unlockedMsg: 'This product has been unlocked, no need to repeat the operation!',
        UnlockSuccessful: 'Tahniah! Berjaya membuka kunci!'
    },
    feedbackPage: {
        title: 'Feedback',
        heroTitle: 'Tell us what happened',
        heroSubtitle: 'We\'ll help you as soon as possible.',
        ticketHistory: 'My Ticket History',
        problemCategory: 'Problem Category',
        issueSelectTitle: 'Please select the specific issue',
        issueSelectSubtitle: 'You can choose one that best matches your situation.',
        next: 'Next',
        form: {
            describeTitle: 'Describe Your Issue',
            describeSubtitle: 'Please provide more details about the problem you are experiencing.',
            describePlaceholder: 'Please describe your issue here... (Max 500 characters)',
            uploadPhotoTitle: 'Upload Photo (Optional)',
            uploadPhotoSubtitle: 'You can upload up to 3 images',
            uploadScreenshotTitle: 'Upload Screenshot (Optional)',
            uploadScreenshotSubtitle: 'Helps us understand the issue better',
            contactEmailTitle: 'Contact Email',
            contactEmailPlaceholder: 'example@email.com',
            orderNoTitle: 'Order Number',
            orderNoPlaceholder: 'Please enter your order number',
            orderNoRequired: 'Please enter your order number',
            takePhoto: 'Take Photo',
            chooseFromAlbum: 'Choose from Album',
            cancel: 'Cancel',
            emailRequired: 'Please enter your contact email',
            emailInvalid: 'Please enter a valid email address',
            describeRequired: 'Please describe your issue',
            uploading: 'Uploading...',
            uploadFailed: 'Image upload failed, please try again',
            submitting: 'Submitting...',
            submitFailed: 'Submission failed, please try again',
            confirmSelected: 'You selected:',
            pleaseMakeSure: 'Please make sure:',
            checkSimInserted: 'Sim card is inserted correctly',
            checkDataPlanActive: 'Your data plan is active',
            checkCameraPowered: 'The camera is powered on',
            checkSignalStrength: 'Signal strength is at least 2 bars',
            checkRestartCamera: 'Try restarting the camera',
            confirmPrompt: 'Please confirm the above issues',
            submit: 'Submit',
        },
        success: {
            title: 'Submitted Successfully!',
            subtitle: 'Our support team has received your request.',
            ticketNumber: 'Ticket Number',
            submitTime: 'Submit Time',
            responseTime: 'We will get back to you within 24 hours (business days).',
            statusCheck: "You can check the status in 'My Tickets'.",
            myTickets: 'My Tickets',
            backToHome: 'Back to Home',
            copySuccess: 'Copied successfully',
        },
        categories: {
            camera: { title: 'Camera', desc: 'Camera offline, cannot view, night vision issue' },
            sim: { title: 'SIM / Network', desc: 'No network, weak signal, SIM problem' },
            recharge: { title: 'Recharge / Data Plan', desc: 'Recharge failed, plan not updated, refund' },
            data: { title: 'Data Usage', desc: 'High data usage, remaining data incorrect' },
            device: { title: 'Device Function', desc: 'Motion detection, cloud storage, recording' },
            order: { title: 'Order & Payment', desc: 'Payment failed, refund, invoice' },
            other: { title: 'Other', desc: 'Other problems' },
        },
        issues: {
            camera_offline: 'Camera Offline',
            cannot_view_live: 'Cannot View Live',
            playback_failed: 'Playback Failed',
            night_vision: 'Night Vision Issue',
            motion_detection: 'Motion Detection',
            camera_restart: 'Camera Restart',
            camera_not_added: 'Camera Not Added',
            sim_not_activated: 'SIM Not Activated',
            no_network: 'No Network',
            weak_signal: 'Weak Signal',
            roaming_issue: 'Roaming Issue',
            sim_replacement: 'SIM Replacement',
            cannot_detect_sim: 'Cannot Detect SIM',
            '4g_not_working': '4G Not Working',
            recharge_failed: 'Recharge Failed',
            recharge_not_effective: 'Recharge Successful But Not Effective',
            plan_not_updated: 'Plan Not Updated',
            wrong_package: 'Wrong Package',
            auto_renewal: 'Auto Renewal',
            subscription: 'Subscription',
            refund: 'Refund',
            coupon: 'Coupon',
            high_data_usage: 'High Data Usage',
            data_used_too_fast: 'Data Used Too Fast',
            remaining_data_incorrect: 'Remaining Data Incorrect',
            usage_not_updated: 'Usage Not Updated',
            need_usage_report: 'Need Usage Report',
            payment_failed: 'Payment Failed',
            duplicate_payment: 'Duplicate Payment',
            order_not_found: 'Order Not Found',
            invoice: 'Invoice',
            discount: 'Discount',
            cloud_storage: 'Cloud Storage',
            recording: 'Recording',
            sd_card: 'SD Card',
            notification: 'Notification',
            firmware_upgrade: 'Firmware Upgrade',
            device_binding: 'Device Binding',
            qr_code: 'QR Code',
            reset_device: 'Reset Device',
            other: 'Other',
        },
        history: {
            tabs: {
                all: 'All',
                processing: 'Processing',
                waiting: 'Waiting',
                resolved: 'Resolved',
                closed: 'Closed',
            },
            status: {
                processing: 'Processing',
                waiting: 'Waiting',
                resolved: 'Resolved',
                closed: 'Closed',
            },
            deviceId: 'Device ID',
            iccid: 'ICCID',
            submitTime: 'Submit Time',
            empty: 'No tickets found',
            loading: 'Loading...',
        },
    },

    PositiveReviewCashbackPopup:{
        title: 'Get free data',
        tip:'with a 5-star review',
        confirm: 'Claim Now'
    },

    newbieCouponPopup: {
        titleOffer: 'Exclusive Offer',
        noThreshold: 'No-threshold Coupon',
        fullReduction: 'Full Reduction Coupon',
        nonSubscribeOnly: 'Exclusive for non-subscription packages',
    }
}
